/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserForDisplayFromJSON, UserForDisplayToJSON } from './UserForDisplay';
export function OrganizationUserEmailSettingFromJSON(json) {
    return OrganizationUserEmailSettingFromJSONTyped(json, false);
}
export function OrganizationUserEmailSettingFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        subjectName: !exists(json, 'subject_name') ? undefined : json['subject_name'],
        isDefault: !exists(json, 'is_default') ? undefined : json['is_default'],
        createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
        updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
        user: !exists(json, 'user') ? undefined : UserForDisplayFromJSON(json['user'])
    };
}
export function OrganizationUserEmailSettingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        subject_name: value.subjectName,
        is_default: value.isDefault,
        created_at: value.createdAt,
        updated_at: value.updatedAt,
        user: UserForDisplayToJSON(value.user)
    };
}
